import React, { Component } from "react";
import styles from "./DashedBtn.module.css";

function DashedBtn({ children, className, link, target }) {
  return (
    <button className={`${styles.dashed} ${styles.thin} ${className}`}>
      {link ? (
        <a
          className={`${styles.btnLink}`}
          href={link}
          target={target ? target : ""}
          rel="noopener noreferrer">
          {children}
        </a>
      ) : (
        children
      )}
    </button>
  );
}

export default DashedBtn;
